import { IMessage } from '@/context/types'

export const getAvatarText = (message: IMessage) => {
  let avatarText = 'PH'

  if (message.author.displayName) {
    const splitName = message.author.displayName.split(' ')
    if (splitName.length > 1) {
      avatarText = `${splitName[0][0]}${splitName[1][0]}`
    } else {
      avatarText = message.author.displayName.slice(0, 2)
    }
  }

  return avatarText.toUpperCase()
}

export const removeWhitespaces = (messageText: string) => {
  const splitMessageText = messageText.split('\n')

  const cleanMessageText = splitMessageText.map(line => line.trim()).join('\n')
  return cleanMessageText
}

export const getAgentInitials = (firstName: string, lastName: string) => {
  const fist = firstName[0] || ''
  const last = lastName[0] || ''

  return [fist, last].join('')
}

export const sortDisplayNames = (list: any[]) => {
  return list.sort((a: any, b: any) => {
    if (a.text < b.text) {
      return -1
    }
    if (a.text > b.text) {
      return 1
    }
    return 0
  })
}

export default {
  getAvatarText,
  removeWhitespaces,
  getAgentInitials,
  sortDisplayNames,
}
